<div class="features">
  <p *ngIf="showSubtitles" class="features-header">
    {{ "PLANS.PLAN_INCLUDES" | translate }}
  </p>
  <ul class="features-list">
    <li *ngFor="let feature of limitableFeatures" class="feature-item">
      <i *ngIf="feature.isAvailable && showCheckIcons" class="feature-icon fas fa-check"></i>
      <span class="feature-count">
        {{ feature.unlimitedUsage || (feature.baseUsageLimit ?? 0) > 99999 ? ("PLANS.UNLIMITED" | translate) : (feature.baseUsageLimit | number) }}
      </span>
      {{ "PLANS.FEATURES." + feature.key | translate }}
      <div class="feature-badges">
        <small *ngIf="!feature.isAvailable" class="badge coming-soon" sxwTooltip="Incredible updates are just around the corner!"> Soon </small>
      </div>
    </li>
  </ul>
</div>

<div *ngIf="showAdditionalFeatures" class="features">
  <p
    *ngIf="showSubtitles"
    class="features-header"
    [innerHTML]="
      includeAllInSmallerPlan
        ? ('PLANS.ALL_FEATURE_IN_PLUS' | translate: { planName: (smallerPlanName || 'previous' | uppercase) })
        : ('PLANS.ADDITIONAL_FEATURES' | translate)
    "></p>
  <ul class="features-list">
    <li *ngFor="let feature of features" class="feature-item">
      <i *ngIf="feature.isAvailable && showCheckIcons" class="feature-icon fas fa-check"></i>
      {{ "PLANS.features." + feature.key | translate }}
      <div class="feature-badges">
        <small *ngIf="!feature.isAvailable" class="badge coming-soon" sxwTooltip="Incredible updates are just around the corner!"> Soon </small>
      </div>
    </li>
  </ul>
</div>
